// extracted by mini-css-extract-plugin
module.exports = {"month":"AllPays__month--1m0Ge","center":"AllPays__center--3ELMF","monthCaption":"AllPays__monthCaption--2O8MK","paymentDate":"AllPays__paymentDate--1FiFZ"};